// Which permission opens which page (any of the codes). A page not listed is
// open to every signed-in user; an empty list = admin only (not grantable).
// Used by the router guard and to build the menus — the server enforces the
// same codes on every endpoint regardless.
import { brandFeature } from '../brand.js'

const REPORTS = ['reports.employees', 'reports.attendance', 'reports.leaves', 'reports.payroll',
  'reports.org', 'reports.disciplinary', 'reports.eos']
const APPROVALS = ['leaves.approve', 'leaves.reject', 'attendance.overtime-approve', 'advances.approve']

export const PAGE_PERMISSIONS = {
  // desktop
  employees: ['employees.view'],
  'employee-profile': ['employees.view'],
  departments: ['employees.view', 'departments.manage'],
  positions: ['employees.view', 'positions.manage'],
  leaves: ['leaves.view-all', 'leaves.approve'],
  'leave-types': ['leave-types.manage'],
  attendance: ['attendance.view-all'],
  timesheet: ['attendance.view-all'],
  assistant: ['assistant.use'],
  'ai-connectors': ['ai.connect'],
  'info-board': ['custom-fields.view'],
  documents: ['documents.view-all'],
  shifts: ['shifts.manage'],
  holidays: ['holidays.manage'],
  biometric: ['biometric.view'],
  payroll: ['payroll.view-all'],
  accounting: ['ledger.view'],
  bonuses: ['bonuses.view'],
  reports: REPORTS,
  disciplinary: ['disciplinary.view'],
  custody: ['custody.view'],
  users: [],
  roles: [],
  'audit-log': ['audit.view'],
  announcements: ['announcements.send'],
  'location-requests': ['location-requests.manage'],
  'field-requests': ['field-requests.manage'],
  // mobile (staff side)
  'm-approvals': APPROVALS,
  'm-team': ['attendance.view-all'],
  'm-timesheet': ['attendance.view-all'],
  'm-assistant': ['assistant.use'],
  'm-info-board': ['custom-fields.view'],
  'm-employees': ['employees.view'],
  'm-employee-profile': ['employees.view'],
  'm-employee-attendance': ['attendance.view-all'],
  'm-employee-custody': ['custody.view'],
  'm-announcements': ['announcements.send'],
  'm-roster': ['attendance.view-all'],
  'm-field-requests-admin': ['field-requests.manage'],
  'm-location-requests': ['location-requests.manage'],
  'm-payroll-runs': ['payroll.view-all'],
  'm-ledger': ['ledger.view'],
  'm-custody': ['custody.view'],
  'm-export': REPORTS,
  'm-settings': ['settings.edit'],
  'm-users': [],
  'm-departments': ['employees.view', 'departments.manage'],
  'm-positions': ['employees.view', 'positions.manage'],
}

// Pages that exist only when the brand ships them: the in-app assistant
// (brand.features.ai) and the ChatGPT/Claude connectors (brand.features.mcp —
// a switch of their own, MCP-SWITCH-2026-10-30).
const BRAND_PAGES = { assistant: 'ai', 'm-assistant': 'ai', 'ai-connectors': 'mcp' }

/** May this user open the page with this route name? */
export function canOpen(auth, name) {
  if (BRAND_PAGES[name] && !brandFeature(BRAND_PAGES[name])) return false
  // The platform console (every tenant) is the platform owner's only page —
  // and theirs alone (super_admin is never grantable).
  if (name === 'platform-admin' || auth.user?.role === 'super_admin') {
    return name === 'platform-admin' && auth.user?.role === 'super_admin'
  }
  const codes = PAGE_PERMISSIONS[name]
  return codes === undefined || auth.can(...codes)
}

export const APPROVAL_PERMISSIONS = APPROVALS
